document.addEventListener("DOMContentLoaded", function () {
  const el = document.getElementById("variant-contents-js");
  if (!el) return;

  const raw = el.getAttribute("data-variants");
  if (!raw) return;

  const variantContents = JSON.parse(raw);
  const target = document.getElementById("variant-contents");

  function updateContents(variantId) {
    const content = variantContents[String(variantId)];
    if (target && content) target.innerHTML = content;
  }

  document.addEventListener("variant:changed", function (e) {
    updateContents(e.detail.variant.id);
  });

  document.addEventListener("change", function (e) {
    const variantSelects = e.target.closest("variant-selects, variant-radios");
    if (variantSelects) {
      const variantInput = document.querySelector('input[name="id"]') ||
                           document.querySelector('[name="id"]');
      if (variantInput) updateContents(variantInput.value);
    }
  });

  updateContents(el.getAttribute("data-selected-variant"));
});